<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Leave Categories</span>
        </h4>
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>

        <div class="mt-4 p-3 ibox">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
                <h4 class="clearfix mb-0">
                    <span class="float-left">Leave Categories
                        <span class="title-sub-text"></span>
                    </span>
                    <span class="float-right"></span>
                </h4>
            </div>
            <div class="row no-gutters py-2 mb-3 pl-0 ">
                <div class="col-sm-6">
                    <div class="custom-search">
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.. " v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title" >
                    <b-button id="show-btn" v-if="ce" @click="addNewLeaveType()"><b-icon icon="plus" ></b-icon> Add Leave Category</b-button>
                </div>
            </div>


            <b-overlay :show="showoverlay" rounded="sm">
                <table class="table dataTable">
                    <thead>
                        <tr class="table-head">

                            <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" class="cursor-pointer"><span>{{column.label}}</span></th>
                            <th class="text-left">Legend Color</th>
                            <th class="text-right" >Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="leavetype in paginatedData" :key="leavetype.id">
                            <td>
                                <b-icon :icon="leavetype.icon || 'calendar'" class="mr-2 text-secondary" font-scale="1.1"></b-icon>
                                {{leavetype.title}}
                            </td>
                            <td>{{yes_no[leavetype.paid_flg].text  }}</td>
                            <td>{{yes_no[leavetype.can_half].text  }}</td>
                            <td>{{yes_no[leavetype.apportion].text  }}</td>
                            <td>{{yes_no[leavetype.can_exceed].text  }}</td>
                            <td v-if="encash == 1">{{yes_no[leavetype.allow_encashment].text  }}</td>
                            <td v-if="carry == 1">{{yes_no[leavetype.carry_flg].text  }}</td>
                            <td><div class="w-100 rounded py-2" v-bind:style="'background:'+leavetype.color_code" >&nbsp;</div></td>
                            <td >

                                <div class="float-right position-relative">
                                    <b-button-toolbar>
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu px-1" aria-labelledby="actionDropdown">
                                            <b-button-group >
                                                <b-button variant="outline-secondary"  @click="editLeaveType(leavetype.id)">
                                                    <b-icon icon="pencil"></b-icon> Edit
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>

                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                                <b-form-select v-model="temp_length" :options="length_options"></b-form-select>
                            </li>
                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number></b-pagination-nav>
                    </div>
                </div>

                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{blankmsg}}</span>
                </div>

            </b-overlay>
        </div>


        <b-modal id="bv-leave-category-modal" size="lg" hide-footer :title="modalTitle">
            <b-overlay :show="showoverlaymodal" rounded="sm">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.id" name="id">

                        <div class="row">
                            <div class="col-sm-4" v-if="fdata.title != 'Compensatory Leave'">
                                <b-form-group id="title-group" label="Title" label-for="title">
                                    <b-form-input id="title" name="title" v-model="fdata.title" v-validate="{ required: true, min: 3 }" :state="validateState('title')" aria-describedby="title-feedback" data-vv-as="Title"></b-form-input>
                                    <b-form-invalid-feedback id="title-feedback">{{ veeErrors.first('title') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div :class="fdata.title != 'Compensatory Leave' ? 'col-sm-4' : 'col-sm-6'" class="roster-color-code">
                                <b-form-group id="color_code-group" class="mb-0">
                                    <div class="d-flex align-items-center justify-content-between ibox border rounded mb-0 row mt-2" style="height: 70px;">
                                        <div class="col-md-6 pr-0">
                                            <label for="color_code" class="px-2 py-0 text-dark mb-0 font-weight-bold text-nowrap">
                                                Color Code
                                            <span class="d-block text-secondary font-weight-normal">{{ fdata.color_code }}</span>
                                        </label>
                                        </div>
                                        <div class="col-md-6 px-0">
                                            <b-form-input id="color_code" name="color_code" v-model="fdata.color_code" type="color" class="border-0 p-0 " style="height: 68px;"></b-form-input>
                                        </div>                                                                                
                                    </div>
                                </b-form-group>
                            </div>

                            <div :class="fdata.title != 'Compensatory Leave' ? 'col-sm-4' : 'col-sm-6'" class="roster-icon-picker">
                                <b-form-group id="icon-group" label="Icon" label-for="icon">
                                    <div class="d-flex align-items-center justify-content-between ibox px-2 py-1 rounded" style="border: 1px solid #ced4da; border-radius: 0.25rem; height: 50px;">
                                        <div class="d-flex align-items-center">
                                            <div class="icon-preview mr-2 d-flex align-items-center justify-content-center bg-light rounded" style="width: 38px; height: 38px; border: 1px solid #ced4da;">
                                                <b-icon :icon="fdata.icon || 'calendar'" font-scale="1.2" class="text-primary"></b-icon>
                                            </div>
                                            <div style="line-height: 1.1;">
                                                <small class="text-muted d-block" style="font-size: 0.75rem;">Selected</small>
                                                <strong class="text-dark" style="font-size: 0.8rem;">{{ fdata.icon || 'calendar' }}</strong>
                                            </div>
                                        </div>
                                        <b-dropdown size="sm" variant="primary" right toggle-class="px-2 py-1" menu-class="p-2">
                                            <template #button-content>
                                                <b-icon icon="grid-fill" class="mr-1"></b-icon>Select
                                            </template>
                                            <div class="d-flex flex-wrap" style="width: 280px; max-height: 200px; overflow-y: auto;">
                                                <b-button 
                                                    v-for="iconName in availableIcons" 
                                                    :key="iconName" 
                                                    variant="light" 
                                                    class="m-1 p-0 d-flex align-items-center justify-content-center" 
                                                    style="width: 32px; height: 32px;"
                                                    :title="iconName"
                                                    :class="{ 'text-white': fdata.icon === iconName }"
                                                    @click="fdata.icon = iconName"
                                                >
                                                    <b-icon :icon="iconName" font-scale="1.0"></b-icon>
                                                </b-button>
                                            </div>
                                        </b-dropdown>
                                    </div>
                                </b-form-group>
                            </div>
                        </div>


                    <div class="bg-wash px-3 py-2 rounded">
                        <div class="row approve-level-content p-0">
                            <div class="col-6">
                                <div class="d-flex flex-row justify-content-between border-bottom align-items-center">
                                    <div class="p-0">
                                        <p class="salary-heads my-2"> <strong>Paid </strong>Leave</p>
                                    </div>
                                    <div>
                                        <b-form-checkbox class="roster-small-switch" v-model="fdata.paid_flg" size="lg"  name="paid_flg" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                                <div class="d-flex flex-row justify-content-between border-bottom align-items-center">
                                    <div>
                                        <p class="salary-heads my-2">Allow <strong>Excess Leave</strong></p>
                                    </div>
                                    <div>
                                        <b-form-checkbox class="roster-small-switch" size="lg" v-model="fdata.can_exceed" name="can_exceed" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <div v-if="fdata.title != 'Compensatory Leave'">
                                        <b-form-group  id="override_leave_policy-group" label="Leave Balance Based On" class="required-field" label-for="override_leave_policy">
                                            <b-form-select id="override_leave_policy" name="override_leave_policy" v-model="fdata.override_leave_policy" :options="leave_balance_based_on" :state="validateState('event')" aria-describedby="override_leave_policy-feedback" data-vv-as="Apply Custom Leave Policy"></b-form-select>
                                            <b-form-invalid-feedback id="override_leave_policy-feedback">{{ veeErrors.first('override_leave_policy') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group id="day_ratio-group" class="required-field" label="Days Required Per Leave" label-for="day_ratio" v-if="fdata.override_leave_policy == 1">
                                            <b-form-input id="day_ratio" name="day_ratio" v-model="fdata.day_ratio"
                                                v-validate="fdata.title != 'Compensatory Leave' && fdata.override_leave_policy == 1
                                                    ? { numeric: true } : {}"
                                                :state="validateState('day_ratio')" aria-describedby="day_ratio-feedback">
                                            </b-form-input>
                                            <b-form-invalid-feedback id="day_ratio-feedback">{{ veeErrors.first('day_ratio') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group  id="leave_days-group" label="Entitlement Days" class="required-field" label-for="leave_days" v-if="fdata.override_leave_policy == 0">
                                            <b-form-input id="leave_days" name="leave_days" v-model="fdata.leave_days"
                                                v-validate="fdata.title != 'Compensatory Leave' && fdata.override_leave_policy == 0
                                                    ? { required: true, min_value: 1, numeric: true } : {}"
                                                :state="validateState('leave_days')" aria-describedby="leave_days-feedback" data-vv-as="Entitlement Days">
                                            </b-form-input>
                                            <b-form-invalid-feedback id="leave_days-feedback">{{ veeErrors.first('leave_days') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div v-if="fdata.title == 'Compensatory Leave'">
                                        <b-form-group id="cmp_exp_days-group" label="Compensatory Leave Expires After" class="required-field" label-for="cmp_exp_days">
                                            <b-form-input id="cmp_exp_days" name="cmp_exp_days" v-model="fdata.cmp_exp_days"
                                                v-validate="fdata.title == 'Compensatory Leave'
                                                    ? { required: true, min_value: 1, numeric: true } : {}"
                                                :state="validateState('cmp_exp_days')" aria-describedby="cmp_exp_days-feedback"
                                                data-vv-as="Compensatory Leave Expires After">
                                            </b-form-input>
                                            <b-form-invalid-feedback id="cmp_exp_days-feedback"> {{ veeErrors.first('cmp_exp_days') }} </b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="d-flex flex-row justify-content-between border-bottom align-items-center">
                                    <div>
                                        <p class="salary-heads my-2">Allow <strong>Half Day Leave</strong></p>
                                    </div>
                                    <div>
                                        <b-form-checkbox @change="fdata.event = 0" class="roster-small-switch" size="lg" v-model="fdata.can_half" name="can_half" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                                <div class="d-flex flex-row justify-content-between border-bottom align-items-center">
                                    <div>
                                        <p class="salary-heads my-2"><strong>Apportion </strong>Based On Joining Date</p>
                                    </div>
                                    <div>
                                        <b-form-checkbox class="roster-small-switch" v-model="fdata.apportion" size="lg"  name="apportion" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                                <div class="mt-3" v-if="fdata.apportion == 1">
                                    <b-form-group  id="rounding-group" label="Rounding" class="required-field" label-for="rounding">
                                        <b-form-select id="rounding" name="rounding" v-model="fdata.rounding" :options="rounding_options" ></b-form-select>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bg-wash rounded px-3 py-2 my-4">
                        <div class="row approve-level-content p-0">
                            <div class="col-sm-12">
                                <div class="d-flex flex-row justify-content-between align-items-center border-bottom mb-3">
                                    <div>
                                        <p class="salary-heads my-2">Allow <strong>Encashment</strong></p>
                                    </div>
                                    <div>
                                        <b-form-checkbox class="roster-small-switch" id="allow_encashment" v-model="fdata.allow_encashment" size="lg" name="allow_encashment" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class=" row" v-if="fdata.allow_encashment == 1">
                        <div class="col-sm-6">
                            <b-form-group id="encashable_days_based_on-group" class="required-field" label="Encashable Days Based On" label-for="encashable_days_based_on">
                                <b-form-select id="encashable_days_based_on" @input="fdata.maximum_encashable_days_in_year = 0;" name="encashable_days_based_on" v-model="fdata.encashable_days_based_on" :options="encashable_days_based_on"></b-form-select>
                            </b-form-group>
                            </div>

                            <div class="col-sm-6">
                                <b-form-group id="based_on_salary_type-group" class="required-field" label="Encashment On" label-for="based_on_salary_type">
                                    <b-form-select id="based_on_salary_type" @change="fdata.encashment_rate = 0;" name="based_on_salary_type" v-model="fdata.based_on_salary_type" :options="based_on_salary_types"></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-sm-6">
                            <b-form-group id="maximum_encashable_days_in_year-group" class="required-field" :label="'Maximum Encashable Days In Year ' + (fdata.encashable_days_based_on == 0 ? '(Days)' : '(%)')" label-for="maximum_encashable_days_in_year">
                                <b-form-input id="maximum_encashable_days_in_year" name="maximum_encashable_days_in_year" v-model="fdata.maximum_encashable_days_in_year" v-validate='{numeric:true}' :state="validateState('maximum_encashable_days_in_year')" aria-describedby="title-feedback" data-vv-as="Maximum Encashable Days In Year"></b-form-input>
                                <b-form-invalid-feedback id="maximum_encashable_days_in_year-feedback">{{ veeErrors.first('maximum_encashable_days_in_year') }}</b-form-invalid-feedback>
                            </b-form-group>
                            </div>

                            <div class="col-sm-6" v-if="fdata.based_on_salary_type == 2">
                            <b-form-group id="encashment_rate-group" class="required-field" label="Daily Rate Of Encashment" label-for="encashment_rate">
                                <b-form-input id="encashment_rate" name="encashment_rate" v-model="fdata.encashment_rate"  v-validate='{numeric:true}' :state="validateState('encashment_rate')" aria-describedby="title-feedback" data-vv-as="Daily Rate of Encashment"></b-form-input>
                                <b-form-invalid-feedback id="encashment_rate-feedback">{{ veeErrors.first('encashment_rate') }}</b-form-invalid-feedback>
                            </b-form-group>
                            </div>


                            <div class="col-sm-12">
                                <b-form-group  id="allow_yearly_encashment_at_separation-group" label="Allow Yearly Encashment At Separation" label-for="allow_yearly_encashment_at_separation">
                                    <b-form-select id="allow_yearly_encashment_at_separation" name="allow_yearly_encashment_at_separation" v-model="fdata.allow_yearly_encashment_at_separation" :options="allow_yearly_encashment_at_separation"></b-form-select>
                                </b-form-group>
                            </div>

                        </div>
                    </div>

                    <div class="bg-wash rounded px-3 py-2">
                        <div class="row approve-level-content p-0">
                            <div class="col-sm-12">
                                <div class="d-flex flex-row justify-content-between align-items-center border-bottom mb-3">
                                    <div>
                                        <p class="salary-heads my-2">Allow <strong>Carry Forward</strong></p>
                                    </div>
                                    <div>
                                        <b-form-checkbox class="roster-small-switch" id="carry_flg" v-model="fdata.carry_flg" size="lg" name="carry_flg" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="fdata.carry_flg == 1">
                        <div class="col-sm-6">
                            <b-form-group id="yearly_carry_forward_based_on-group" class="required-field" label="Yearly Carry Forward Based On" label-for="yearly_carry_forward_based_on">
                            <b-form-select id="yearly_carry_forward_based_on" @input="fdata.carry_days = 0;" name="yearly_carry_forward_based_on" v-model="fdata.full_carry" :options="yearly_carry_forward_based_on"></b-form-select>
                            </b-form-group>
                        </div>

                        <div class="col-sm-6" v-if="fdata.full_carry != 1">
                            <b-form-group id="carry_days-group" class="required-field" label="Carry Forward Limit In Year" label-for="carry_days">
                            <b-form-input id="carry_days" name="carry_days" v-model="fdata.carry_days"  v-validate='{numeric:true}' :state="validateState('carry_days')" aria-describedby="carry_days-feedback" data-vv-as="Maximum Carry Forward Days"></b-form-input>
                            <b-form-invalid-feedback id="carry_days-feedback">{{ veeErrors.first('carry_days') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        </div>


                        <div class=" row approve-level-content p-0" v-if="fdata.carry_flg == 1">
                            <div class="col-sm-6">
                                <div class="d-flex flex-row justify-content-between align-items-center border-bottom">
                                    <div>
                                        <p class="salary-heads my-2">Set Lifetime <strong>Carry Forward Limit</strong></p>
                                    </div>
                                    <div>
                                        <b-form-checkbox id="lifetime_carry_forward_limit" @change="fdata.max_carry_forward = 0;" v-model="fdata.lifetime_carry_forward_limit" size="lg" name="lifetime_carry_forward_limit" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                                <div class="mt-2" v-if="fdata.lifetime_carry_forward_limit == 1">
                                    <b-form-group id="max_carry_forward-group" class="required-field" label="Lifetime Maximum Carry Forward Days" label-for="max_carry_forward">
                                    <b-form-input id="max_carry_forward" name="max_carry_forward" v-model="fdata.max_carry_forward"  v-validate='{numeric:true}' :state="validateState('max_carry_forward')" aria-describedby="max_carry_forward-feedback" data-vv-as="Carry Forward Limit in Year"></b-form-input>
                                    <b-form-invalid-feedback id="max_carry_forward-feedback">{{ veeErrors.first('max_carry_forward') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </div>

                        </div>
                        <div class=" row approve-level-content p-0" v-if="fdata.carry_flg == 1">
                            <div class="col-sm-6">
                                <div class="d-flex flex-row justify-content-between align-items-center">
                                    <div>
                                        <p class="salary-heads my-2">Allow <strong>Taking Leave From Carry Balance</strong></p>
                                    </div>
                                    <div>
                                        <b-form-checkbox id="allow_taking_leave_from_carry_balance" v-model="fdata.allow_taking_leave_from_carry_balance" size="lg" name="allow_taking_leave_from_carry_balance" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="d-flex flex-row justify-content-between align-items-center">
                                    <div>
                                        <p class="salary-heads my-2">Allow <strong>Encashment on Carry Balance</strong></p>
                                    </div>
                                    <div>
                                        <b-form-checkbox id="allow_encashment_on_carry_balance" v-model="fdata.allow_encashment_on_carry_balance" size="lg" name="allow_encashment_on_carry_balance" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div class="bg-wash rounded px-3 py-4 my-4">
                    <div class="row">
                        <div class="col-sm-12">                            
                            <b-form-group  id="event-group" label="Usage Limit (Lifetime)" class="required-field" label-for="event">
                                <b-form-select id="event" name="event" v-model="fdata.event" :options="event_options"
                                @change="checkOffDayOnLeave"
                                :state="validateState('event')" aria-describedby="event-feedback" data-vv-as="Usage Limit (Lifetime)"></b-form-select>
                                <b-form-invalid-feedback id="event-feedback">{{ veeErrors.first('event') }}</b-form-invalid-feedback>
                            </b-form-group>
                            <div class="border-bottom mt-4 mb-3"></div>
                        </div>
                        <div class="col-sm-12" v-if="roster == 1 && fdata.event == 0">
                            <div class="roster-leave-type">
                                <b-form-group label="Leave Category Type" label-class="mb-1" class="leave-attendance-legends col-12 required-field px-0">
                                    <b-form-radio-group
                                        @change="checkOffDayOnLeave"
                                        class="leave-attendance-btns w-100"
                                        v-model="fdata.leave_basis"
                                        :options="leave_basis"
                                        buttons
                                        button-variant="outline-secondary"
                                        :state="validateState('event')"
                                        aria-describedby="leave_basis-feedback">
                                    </b-form-radio-group>
                                    <b-form-invalid-feedback id="leave_basis-feedback">{{ veeErrors.first('leave_basis') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                        </div>
                        <div class="col-sm-12">
                        <b-form-group id="off_day_on_leave-group" label="Off Day  & Public Holidays In Calculation" label-for="off_day_on_leave" >
                            <b-form-select :disabled="fdata.event > 0 || fdata.leave_basis == 1" id="off_day_on_leave" name="off_day_on_leave" v-model="fdata.off_day_on_leave" :options="off_day_on_leave_options"  v-b-tooltip.hover title="Will be applicable from future leave application"></b-form-select>
                        </b-form-group>
                        </div>
                    </div>
                    </div>

                    <div class="d-flex justify-content-center">
                        <b-button type="submit" variant="primary">Submit</b-button>
                        <b-button class="ml-2 custom-wizard-btn" @click="$bvModal.hide('bv-leave-category-modal')" variant="primary">Cancel</b-button>
                        <b-button class="ml-2 custom-wizard-btn" variant="primary" @click="resetForm()">Reset</b-button>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>

    </div>
</template>


<script>
    export default{

        mounted() {
        },
        props: [],
        data(){
            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'title' },
                            {label: 'Paid', name: 'paid_flg'},
                            {label: 'Half Day', name: 'can_half'},
                            {label: 'Apportion', name: 'apportion'},
                            {label: 'Take Excess', name: 'can_exceed'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {
                cu : window.location.href,
                ce : true,
                roster: 0,
                pagetitle: 'Leave Category',
                search:'',
                leavetypes : [],
                successmsg : '',
                errormsg : [],
                carry: 0,
                encash: 0,
                blankmsg : 'Fetching data..',
                fdata : {
                  id:0,
                  title: '' ,
                  can_half:0,
                  can_exceed:0,
                  paid_flg : 0 ,
                  carry_flg : 0,
                  color_code : '#aaaaaa' ,
                  icon: 'calendar',
                  carry_days:0 ,
                  full_carry:0 ,
                  cmp_exp_days: 0,
                  max_carry_forward:0 ,
                  apportion:1,
                  rounding:1,
                  allow_encashment:0,
                  based_on_salary_type:0,
                  encashment_rate: 0,
                  encashable_days_based_on: 0,
                  maximum_encashable_days_in_year: 0,
                  allow_yearly_encashment_at_separation:0,
                  yearly_carry_forward_based_on:0,
                  lifetime_carry_forward_limit:0,
                  allow_encashment_on_carry_balance:0,
                  allow_taking_leave_from_carry_balance: 0,
                  event: '0',
                  leave_basis: '0',
                  off_day_on_leave: '0',
                  override_leave_policy: '0',
                  day_ratio: '18',
                  leave_days: 0,
                },
                availableIcons: [
                    'calendar',
                    'calendar-check',
                    'calendar-event',
                    'calendar-range',
                    'calendar2-range',
                    'calendar3',

                    'umbrella',
                    'sun',
                    'moon',
                    'cloud',
                    'snow',
                    'wind',
                    'lightning',

                    'heart',
                    'heart-fill',
                    'heart-half',
                    'file-medical',
                    'shield-plus',

                    'person',
                    'people',
                    'house',
                    'gift',
                    'briefcase',

                    'emoji-smile',
                    'emoji-neutral',
                    'emoji-frown',

                    'clock',
                    'hourglass',
                    'hourglass-split',

                    'award',
                    'award-fill',
                    'star',
                    'star-fill',
                    'bell',
                    'bell-fill',

                    'cash',
                    'wallet',
                    'credit-card',

                    'file-text',
                    'file-earmark-text',
                    'bookmark',
                    'flag',
                    'tag'
                ],


                event_options : [
                  { value: "0", text: "Auto" },
                  { value: "1", text: "1" },
                  { value: "2", text: "2" },
                  { value: "3", text: "3" },
                  { value: "4", text: "4" },
                  { value: "5", text: "5" },
                ],

                off_day_on_leave_options:[

                  { value: "0", text: "Include off day and public holidays in leave days calculation" },
                  { value: "1", text: "Skip off day and public holidays in leave days calculation" },
                  { value: "2", text: "Include adjacent off day and public holidays in leave days calculation" },
                ],
                showoverlay : false,
                showoverlaymodal : false,

                yes_no:[
                    { value: "0", text: "No" },
                    { value: "1", text: "Yes" },
                ],
                leave_balance_based_on:[
                    { value: "0", text: "Fixed Balance" },
                    { value: "1", text: "Acrual Frequency" },
                ],
                based_on_salary_types:[
                    { value: "0", text: "Basic salary" },
                    { value: "1", text: "Gross salary" },
                    { value: "2", text: "Fixed Rate" },
                ],

              allow_encashment_on_carry_balance:[
                { value: "0", text: "No" },
                { value: "1", text: "Yes" },
              ],
                encashable_days_based_on:[
                    { value: "0", text: "Number of Days" },
                    { value: "1", text: "Percentage" },
                ],
                leave_basis:[
                    { value: "0", text: "Day Basis" },
                    { value: "1", text: "Shift Basis" },
                ],
                allow_yearly_encashment_at_separation:[
                    { value: "0", text: "No (Remaining Lapsed)" },
                    { value: "1", text: "As Per encashable Days Per Year" },
                    { value: "2", text: "All Remaining" },
                ],
              yearly_carry_forward_based_on:[
                    { value: "1", text: "None (All Remaining)" },
                    { value: "0", text: "Number of Days" },
                    { value: "2", text: "Percentage" },
                ],
                rounding_options : [
                    { value: "1", text: "Round Up" },
                    { value: "2", text: "Round Down" },
                    { value: "3", text: "Rounded to nearest integer" },
                ],

                columns: columns,
                sortKey: 'title',
                sortOrders: sortOrders,

                pagination: {currentPage: 1, total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                temp_length: 10,
                people: 0,
                length_options: [
                    { value: 10, text: "10" },
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" },
                ],

                modalTitle: 'Leave Category Details',

            }
        },
        methods:{
            checkOffDayOnLeave(){
                if(this.fdata.event > 0)
                {
                    this.fdata.off_day_on_leave = 0;
                    this.fdata.can_half = 0;
                }
                if(this.fdata.leave_basis == 1) {
                    this.fdata.off_day_on_leave = 1;
                }
            },
            getTypeList: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/leave-attendance/leave/types').then(function(response){
                    this.leavetypes = response.data;
                    this.pagination.total = response.data.length;
                    this.showoverlay = false;

                    if(this.leavetypes.length == 0)
                        this.blankmsg = "Nothing found.";
                }.bind(this));
            },
            editLeaveType:function(x)
            {
                if(!this.checkNet()) return false;
                this.errormsg = [];
                this.successmsg = '';
                this.modalTitle = 'Edit Leave Category';

                axios.get(this.$api_url+'/leave-attendance/leave/type/details/'+x).then((response) => {
                    this.fdata = response.data;
                    this.fdata.encashment_rate = response.data.encashment_rate;
                    this.$bvModal.show('bv-leave-category-modal');
                    this.$validator.reset();
                }).catch( (error) => {
                    this.serverError(error);
                });


            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                  id:0,
                  title: '' ,
                  can_half:0,
                  can_exceed:0,
                  paid_flg : 0 ,
                  carry_flg : 0,
                  color_code : '#aaaaaa' ,
                  icon: 'calendar',
                  carry_days:0 ,
                  cmp_exp_days: 0,
                  full_carry:0 ,
                  max_carry_forward:0 ,
                  apportion:1,
                  rounding:1,
                  allow_encashment:0,
                  based_on_salary_type:0,
                  encashment_rate: 0,
                  encashable_days_based_on: 0,
                  maximum_encashable_days_in_year: 0,
                  allow_yearly_encashment_at_separation:0,
                  yearly_carry_forward_based_on:0,
                  lifetime_carry_forward_limit:0,
                  allow_encashment_on_carry_balance:0,
                  allow_taking_leave_from_carry_balance: 0,
                  event: '0',
                  leave_basis: '0',
                  off_day_on_leave: '0',
                  override_leave_policy: '0',
                  day_ratio: '18',
                  leave_days: 0,
                };
            },
            addNewLeaveType()
            {
                this.modalTitle = 'Add Leave Category';
                this.resetForm();
                this.$bvModal.show('bv-leave-category-modal');
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlaymodal = true;
                    e.preventDefault();

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    axios.post(this.$api_url+'/leave-attendance/leave/type/save', formData).then((response) => {
                            this.leavetypes = response.data;
                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.$bvModal.hide('bv-leave-category-modal');
                            this.showoverlaymodal = false;
                            this.resetForm();

                        }).catch((error) => {
                            this.serverError(error);
                            this.errormsg = error.response.data.errors;
                            for (var data in this.errormsg)
                            {
                                var msg = this.errormsg[data];
                              this.$bvToast.toast(msg, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });
                              this.$validator.reset();
                            }
                        });
                });
            },

            getCompanyLeaveSettings:function()
            {
            if(!this.checkNet()) return false;
            axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

                if(response.data.length != 0)
                {
                  this.roster = response.data.roster;
                  this.carry = response.data.carry;
                  this.encash = response.data.encash;
                  if(this.carry == 1) {
                      this.columns.push({label: 'Carry', name: 'carry_flg'});
                  }
                  if(this.encash == 1) {
                      this.columns.push({label: 'Encashment', name: 'allow_encashment'});
                  }
                }
            }.bind(this));
            },

        },
        created: function(){
            this.getTypeList();
            this.getCompanyLeaveSettings();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.leavetypes.filter((row) => row.title != 'Long Service Leave');
                this.people = filtered_list.length;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type == 'date')
                            {
                                return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type == 'number')
                            {
                                return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a == b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
            }
        }
    }
</script>
